import {
  FilterState,
  Rules,
  RulesState,
} from '../../dashboard/components/Rules/types';

export const DEFAULT_RULES: Rules = {
  quantity: [],
  pricing: [],
  visibility: [],
};

export const DEFAULT_FILTER: FilterState = {
  dispensary_class_id: null,
  brand_id: null,
  category_id: null,
  product_id: null,
  stock_location_id: null,
  size: null,
};

const rulesState: RulesState = {
  rules: DEFAULT_RULES,
  perms: null,
  fields: null,
  restrictions: null,

  filter: DEFAULT_FILTER,
  isLoading: false,
  isUpdating: false,
  error: null,
  isInitialized: false,

  pendingChanges: {},

  url: '',
};

export default rulesState;
